export default function LocationsController(
    $scope,
    Scroll,
    siteService,
    UrlFactory,
    $location,
    locations // resolved
) {
    // LocationService.getAll().then((locations) => {
    //     $scope.locations = locations
    //         .filter((locations) => locations.name != "*")
    //         .map((x) => {
    //             if (x.img == null) {
    //                 x.img = "images/NoPhoto.gif";
    //             }
    //             return x;
    //         });
    // });

    $scope.locations = locations
        .filter((locations) => locations.name != "*")
        .map((x) => {
            if (x.img == null) {
                x.img = "images/NoPhoto.gif";
            }
            return x;
        });

    $scope.selectLocation = function (location) {
        const slug = UrlFactory.slugify(location.name);
        $location.path("/locations/" + slug);
    };

    Scroll.to("title-focus", siteService.headerHeight + 15);
}
